import "core-js/modules/es.function.name";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import { __awaiter, __generator } from "tslib";
import { ROUTE_NAME } from '@/lib/constant';
import Loading from '@/pages/extra/loading.vue';
import store from '@/store';
export default [{
  path: '/team/manage/detail/:activityId/:teamId',
  name: ROUTE_NAME.TEAM_MANAGE_DETAIL,
  meta: {
    title: '战队管理',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    disableShare: true,
    checkMonitor: true,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/team/manage/detail.vue');
  }
}, {
  path: '/team/manage/list/:activityId',
  name: ROUTE_NAME.TEAM_MANAGE_LIST,
  meta: {
    title: '战队管理',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    disableShare: true,
    checkMonitor: true,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/team/manage/list.vue');
  }
}, {
  path: '/team/recruit_rank/:activityId',
  name: ROUTE_NAME.TEAM_RECRUIT_RANK,
  meta: {
    title: '队长招募榜',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    disableShare: true,
    checkMonitor: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/team/recruitRank.vue'),
      loading: Loading
    };
  }
}, {
  path: '/team/manage/influence/:teamId/:activityId',
  name: ROUTE_NAME.TEAM_MANAGE_INFLUENCE,
  meta: {
    title: '影响人数',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    disableShare: true,
    checkMonitor: true,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/team/manage/influence.vue'),
      loading: Loading
    };
  }
}, {
  path: '/team/share/:activityId',
  name: ROUTE_NAME.TEAM_SHARE,
  meta: {
    title: '邀请队长分享',
    scrollBehavior: 'top',
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/team/share.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/redirect/:activityId',
  name: ROUTE_NAME.MONITOR_REDIRECT,
  meta: {
    title: ''
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/redirect.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/activity_list',
  name: ROUTE_NAME.MONITOR_ACTIVITY_LIST,
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/monitor/activityList.vue');
  }
}, {
  path: '/monitor/setting_before/:activityId/:teamId',
  name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
  meta: {
    title: '战队设置',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/settingBefore.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/setting/:activityId/:teamId',
  name: ROUTE_NAME.MONITOR_SETTING,
  meta: {
    title: function title(to) {
      var activityId = to.params.activityId;
      var basicInfo = store.state.activity.basicInfo[activityId];
      return (basicInfo ? basicInfo.name : '') + "\u6218\u961F\u4FE1\u606F\u66F4\u65B0";
    },
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true,
    disableShare: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/setting.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/setting/:teamId',
  beforeEnter: function beforeEnter(to, from, next) {
    return __awaiter(this, void 0, void 0, function () {
      var teamId, team;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            teamId = to.params.teamId;
            store.commit('startRequest');
            return [4
            /*yield*/
            , store.dispatch('activity/getTeamDetail', {
              teamId: teamId
            })];

          case 1:
            _a.sent();

            store.commit('endRequest');
            team = store.state.activity.team.detail[Number(teamId)];

            if (!team) {
              next(false);
              return [2
              /*return*/
              ];
            }

            next({
              name: ROUTE_NAME.MONITOR_SETTING_BEFORE,
              params: {
                activityId: team.activity_id,
                teamId: teamId
              }
            });
            return [2
            /*return*/
            ];
        }
      });
    });
  }
}, {
  path: '/team/manage/signin/detail/:activityId/:teamId/:date/:nav?',
  name: ROUTE_NAME.TEAM_MANAGE_SIGNIN_DETAIL,
  meta: {
    title: '打卡明细',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true,
    disableShare: true,
    checkMonitor: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/team/manage/signInDetail.vue'),
      loading: Loading
    };
  }
}, {
  path: '/team/manage/signin/calendar/:activityId/:teamId/:userId/:date',
  name: ROUTE_NAME.TEAM_MANAGE_SIGNIN_CALENDAR,
  meta: {
    title: '打卡日历',
    scrollBehavior: 'restore',
    scrollDefaultPosition: 0,
    needBinding: true,
    disableShare: true,
    checkMonitor: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/team/manage/signInCalendar.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/invite/:activityId',
  name: ROUTE_NAME.MONITOR_INVITE,
  meta: {
    title: '邀请队长，可得1000元奖金',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/invite.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/invite_team/:activityId',
  name: ROUTE_NAME.MONITOR_INVITE_TEAM,
  meta: {
    title: '邀请队伍',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/inviteTeam.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/invite_team_detail/:teamId',
  name: ROUTE_NAME.MONITOR_INVITE_TEAM_DEATIL,
  meta: {
    title: '邀请队伍',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return {
      component: import(
      /* webpackChunkName: "monitor" */
      '@/pages/monitor/inviteTeamDetail.vue'),
      loading: Loading
    };
  }
}, {
  path: '/monitor/question/:activityId/:predicatedMemberCount',
  name: ROUTE_NAME.MONITOR_QUESTION,
  meta: {
    title: '申请表单',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/monitor/question.vue');
  }
}, {
  path: '/monitor/result/:activityId',
  name: ROUTE_NAME.MONITOR_RESULT,
  meta: {
    title: '笔试结果',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/monitor/result.vue');
  }
}, {
  path: '/monitor/team/:activityId',
  name: ROUTE_NAME.MONITOR_TEAM,
  meta: {
    title: '创建战队',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/monitor/team.vue');
  }
}, {
  path: '/monitor/interview/:activityId',
  name: ROUTE_NAME.MONITOR_INTERVIEW,
  meta: {
    title: '面试',
    scrollBehavior: 'top',
    scrollDefaultPosition: 0,
    needBinding: true
  },
  component: function component() {
    return import(
    /* webpackChunkName: "monitor" */
    '@/pages/monitor/interview.vue');
  }
}];